function isIe(userAgent: string): boolean {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent: string): boolean {
  return userAgent.indexOf('Edge/') !== -1;
}

export function isIeOrEdge(userAgent: string = window?.navigator.userAgent): boolean {
  if (!userAgent) {
    return false;
  }

  return isIe(userAgent) || isEdge(userAgent);
}
